class TecobiSmsWidgetController {

  constructor($window, $scope, TecobiSmsWidgetService) {
    'ngInject';
    this.$window = $window;
    this.$scope = $scope;
    this.TecobiSmsWidgetService = TecobiSmsWidgetService;
  }

  showPopup() {
      document.getElementById('tecobiSmsWidgetMessageInput').blur();
      this.showInChatSmsPopup = true;
  }

  toggleChatBox() {

      // Scan user agent and set iOS variable
      const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (iOS && !this.chatBoxOpen) {
          // scroll down for iOS devices
          this.$window.scrollTo(0, document.body.scrollHeight);
      }
      angular.element('body').toggleClass('tecobi-sms-widget-open');
      this.chatBoxOpen = !this.chatBoxOpen;

      if (this.chatBoxOpen && 'function' === typeof ga) {
          let arr = [];
          ga(function() {
              // Logs an array of all tracker objects.
              arr = ga.getAll();
          });
          arr.forEach(function(e, i){
              let trackerName = e.get('name');
              trackerName += '.send';
              let dataObj = {
                  hitType: 'event',
                  eventCategory: 'cta',
                  eventAction: 'click',
                  eventLabel: 'tecobi direct widget click'
              }
              console.log(trackerName, dataObj);
              ga(trackerName, dataObj);
          });
      } else if (this.chatBoxOpen && 'function' === typeof gtag) {
        gtag('event', 'tecobi_widget_lead', {
          'event_category': 'TECOBI Widget',
          'event_label': 'click'
        });
      }
  }

  setUpForm() {
      this.showInChatSmsPopup = false;
      this.smsMessage = {
        client: this.client,
        lead_type: 'Web',
        classification: 'Sales',
        message: ''
      };
  }

  resetForm() {
      this.setUpForm();
      this.smsMessageForm.$setPristine();
      this.smsMessageForm.$setUntouched();
      this.smsInfoForm.$setPristine();
      this.smsInfoForm.$setUntouched();
  }

  listenToCTAClick() {
    var _self = this;
    angular.element('body').on('click', '.tecobi-widget-toggle', function(e) {
      e.preventDefault();
      var $this = angular.element(this);
      _self.smsMessage.message = $this.text();
      if (_self.smsMessage.message) {
        _self.showPopup();
      }
      _self.toggleChatBox();
      _self.$scope.$digest();
    });
  }

  $onInit() {
    this.setUpForm();
    // HTTP request to get the widget config for a client
    this.TecobiSmsWidgetService.getClientInfo(this.client);
    this.listenToCTAClick();
  }

  submit(params) {
    // Copy the model so we can mutate it a bit
    let data = angular.copy(params);
    // Add URL to the message
    data.message = `${data.message} \n\nFrom: ${this.$window.location.href}`;
    // Serializer requires first name
    data.first_name = data.first_name || 'Unknown';
    // Serializer requires last name
    data.last_name = data.last_name || 'Unknown';
    // Format the number with a +1 for the DB
    data.phone_number = `+1${this.smsMessage.phone_number}`;
    // POST data to the API to create a lead
    return this.TecobiSmsWidgetService.createMessage(data).then((res) => {
      // close the widget
      this.toggleChatBox();
      // reset the form
      this.resetForm();
      // Trigger a link track conversion only on the tecobi client
      if ('function' === typeof window.lintrk && res.client === 5) {
        window.lintrk('track', { conversion_id: 12178242 });
      }
      // Trigger a google analytics event if ga is a installed
      if ('function' === typeof ga) {
          let arr = [];
          ga(function() {
              // Logs an array of all tracker objects.
              arr = ga.getAll();
          });
          console.log(arr);
          arr.forEach(function(e, i){
              let trackerName = e.get('name');
              trackerName += '.send';
              let dataObj = {
                  hitType: 'event',
                  eventCategory: 'lead',
                  eventAction: 'created',
                  eventLabel: 'tecobi-widget-lead'
              }
              console.log(trackerName, dataObj);
              ga(trackerName, dataObj);
              if ('object' === typeof dataLayer) {
                dataLayer.push({'event': 'tecobi-widget-lead'});
              }
          });
      } else if ('function' === typeof gtag) {
        gtag('event', 'tecobi_widget_lead', {
          'event_category': 'TECOBI Widget',
          'event_label': 'Lead Submission'
        });
        gtag('event', 'conversion', {
          'send_to': 'AW-748473245/hYuWCIC-tvEBEJ2X8-QC',
          'value': 0,
          'currency': 'USD',
          'transaction_id': String(res.id)
        });
      }
    });
  }

}

export default TecobiSmsWidgetController;



// WEBPACK FOOTER //
// ./client/app/components/tecobiSmsWidget/tecobiSmsWidget.controller.js